/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_SCHEDULE_LIST = gql`
  query GetSchedules(
    $options: GetManyOptions
    $filter: ScheduleFilterInput
    $distFilter: DistCentFilterInput
  ) {
    getSchedules(options: $options, filter: $filter) {
      count
      limit
      skip
      currentPage
      content {
        id
        maxAttendees
        isPublished
        genders
        eventStartTime
        eventEndTime
        distCent {
          id
          name
        }
        description
        createdAt
        band {
          id
          name
        }
        vipOnly
        scheduleID
        attendeesCount
        sections
        sectionOptTypes
        name
        isPaused
      }
    }

    getDistCents(filter: $distFilter) {
      content {
        distCenterId
        id
        name
        noOfCounters
      }
    }
  }
`;
